
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.485 3.515A11.921 11.921 0 0012 0a11.921 11.921 0 00-8.485 3.515A11.921 11.921 0 000 12c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0012 24c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0024 12c0-3.205-1.248-6.219-3.515-8.485zM12 11.25a3.379 3.379 0 013.375 3.375 3.38 3.38 0 01-2.452 3.246.235.235 0 00-.173.226v.632c0 .404-.31.751-.714.77a.75.75 0 01-.786-.749v-.654a.235.235 0 00-.172-.225 3.38 3.38 0 01-2.453-3.225.762.762 0 01.728-.77.75.75 0 01.772.749c0 1.078.915 1.947 2.009 1.87a1.882 1.882 0 001.736-1.736A1.877 1.877 0 0012 12.75a3.379 3.379 0 01-3.375-3.375 3.38 3.38 0 012.452-3.246.235.235 0 00.173-.226v-.632c0-.404.31-.751.714-.77a.75.75 0 01.786.749v.653c0 .106.07.197.172.226a3.38 3.38 0 012.453 3.225.762.762 0 01-.728.77.75.75 0 01-.772-.749 1.877 1.877 0 00-2.009-1.87A1.882 1.882 0 0010.13 9.24 1.877 1.877 0 0012 11.25z","fill":"#838383"}})])
          )
        }
      }
    